import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators, FormBuilder } from '@angular/forms';
import { Platform } from '@angular/cdk/platform';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Device } from '@capacitor/device';
import { AuthService } from '../../core/services/auth.service';
import { EventService } from '../../core/services/event.service';
import { Location } from '@angular/common';
import { PhotowallService } from 'src/app/core/services/photowall.service';
import { distinctUntilChanged } from 'rxjs';


@Component({
  selector: 'app-add-hashtags',
  templateUrl: './add-hashtags.component.html',
  styleUrls: ['./add-hashtags.component.css'],
  encapsulation: ViewEncapsulation.Emulated
})
export class AddHashtagsComponent implements OnInit {
  formGroup!: FormGroup;
  hashtags: string[] = [];
  showMessage: string = '';
  subtext: string = '';
  showhashtag: boolean = false;
  isSavingData: boolean = false;
  isbtnDisabled: boolean = true;

  constructor(private fb: FormBuilder, private photoService: PhotowallService,
    public dialog: MatDialog,
    private location: Location,
    private authService: AuthService,
    private router: Router,
    private platform: Platform) {
    this.formGroup = this.fb.group({
      showHashtag: [true],
      textAboveHashtag: [''],
      hashtagInput: ['', [Validators.pattern(/^[a-zA-Z0-9]+$/)]]
    });
  }

  async ngOnInit(): Promise<void> {
    this.isSavingData = true;

    // Fetch hashtags and populate form
    (await this.photoService.gethashtags(localStorage.getItem('e'))).subscribe({
      next: (res) => {
        // console.log(res); //__CONSOLE_LOG__
        let response: any = res;

        // Set initial form values
        this.formGroup.patchValue({
          showHashtag: response.show_hashtag,
          textAboveHashtag: response.hashtag_subtext,
          hashtagInput: response.hashtags
        });

        this.isSavingData = false;

        // Now subscribe to value changes only after the form is populated
        this.addFormSubscriptions();
      }
    });
}

// Separate method to handle value changes after form is initialized
addFormSubscriptions(): void {
    // Subscribe to value changes for 'showHashtag'
    this.formGroup.get('showHashtag')?.valueChanges.pipe(distinctUntilChanged())
      .subscribe(value => {
        // console.log(value); //__CONSOLE_LOG__
        if (!value) { // if the toggle is switched to off
          this.formGroup.patchValue({ showHashtag: false });
          this.saveHashtags(); // Save when toggled off
        } else {
          this.textChange(); // Handle text changes when toggled on
        }
      });

    // Subscribe to value changes for 'textAboveHashtag'
    this.formGroup.get('textAboveHashtag')?.valueChanges.subscribe(() => {
      this.textChange();
    });

    // Subscribe to value changes for 'hashtagInput'
    this.formGroup.get('hashtagInput')?.valueChanges.subscribe(() => {
      this.textChange();
    });
}


  
  textChange(): void {
    this.isbtnDisabled = false;
  }

  // addHashtag(event: any): void {
  //   const hashtag = this.hashtagForm.value.hashtagInput.trim();
  //   if (event) {
  //     event.preventDefault();
  //   }
  //   if (hashtag && this.hashtagForm.valid) {
  //     this.hashtags.push(hashtag);
  //     this.hashtagForm.reset();
  //   }
  // }

  removeHashtag(index: number): void {
    this.hashtags.splice(index, 1);
  }

  async saveHashtags(): Promise<void> {
    this.isSavingData = true;
    this.isbtnDisabled = true;
    const showHashtag = this.formGroup.value.showHashtag;

    if (showHashtag) {
      const hashtag = this.formGroup.value.hashtagInput.trim();
      this.hashtags = [hashtag]; // Only allow one hashtag
      const subtext = (this.formGroup.value.textAboveHashtag != null && this.formGroup.value.textAboveHashtag != undefined) ? this.formGroup.value.textAboveHashtag : ' ';
      // console.log(this.formGroup.value); //__CONSOLE_LOG__

      // const formattedHashtags = this.hashtags.map(tag => `#${tag}`).join(', ');
      // console.log('Saved Hashtags:', formattedHashtags);
      // // Here you can save the formattedHashtags string to your backend or local storage
      // localStorage.setItem('savedHashtags', formattedHashtags);

      (await this.photoService.saveHashtags(localStorage.getItem('e'), showHashtag, this.hashtags, subtext)).subscribe({
        next: (res) => {
          // console.log(res); //__CONSOLE_LOG__
          let response: any;
          response = res;

          this.showMessage = response['result'];
          this.isSavingData = false;
        }
      });
     
    }
    else {
      (await this.photoService.saveHashtags(localStorage.getItem('e'), showHashtag, '', '')).subscribe({
        next: (res) => {
          // console.log(res); //__CONSOLE_LOG__
          let response: any;
          response = res;

          this.showMessage = response['result'];
          this.isSavingData = false;
        }
      });
   
    }
  }

  logout() {
    this.authService
      .signOut()
      .then((res) => {
        this.router.navigateByUrl(
          "/auth/login"
        );
      })
      .catch((err) => {
        // console.error(err); //__CONSOLE_LOG__
      });
  }

  goBack() {
    // localStorage.removeItem('eventId');
    this.location.back();
  }


  async downloadApp() {
    const info = await Device.getInfo();

    if (this.platform.IOS && info.model === 'iPhone' && info.platform === 'web') {
      window.location.href = 'https://apps.apple.com/in/app/picaggo/id1527686260';
    }

    if (this.platform.ANDROID && info.platform === 'web') {
      window.location.href = 'https://play.google.com/store/apps/details?id=application.share.photo.picaggo';
    }
  }
}